<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>Income</h3>
          <v-btn icon color="primary" @click="showD=!showD" class="elevation-5">
            <v-icon>add</v-icon>
          </v-btn>

          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn color="success" @click="exportAllIncome()" v-on="on">Excel</v-btn>
            </template>
            <span>Export all income this term to excel</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            style="max-width:40%"
          ></v-text-field>
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-data-table
                :headers="inc_headers"
                :items="incomes"
                class="elevation-0"
                :search="search"
                :loading="loading"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">{{ props.index + 1 }}</td>
                  <td
                    class="text-xs-center"
                  >{{ props.item.ledgeracc&&props.item.ledgeracc.name?props.item.ledgeracc.name:'N/A' }}</td>
                  <td class="text-xs-center">{{ props.item.description }}</td>
                  <td class="text-xs-center">{{ props.item.amount | toCurrency }}</td>
                  <td class="text-xs-center">{{ props.item.jdate }}</td>
                  <td class="text-xs-center">{{ props.item.recorded_by.name }}</td>

                  <td class="text-xs-center">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-btn flat icon color="blue" @click="editjournal(props.item)">
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs6>
                        <v-btn
                          flat
                          icon
                          color="pink"
                          @click="deletejournal(props.item,props.index)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <!-- add-edit income dialog -->
      <inc-dialog pers title="Income" :show="showD">
        <template v-slot:header-actions>
          <v-btn @click="showD=!showD" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <v-form ref="form">
            <v-autocomplete
              :items="ledgeraccs"
              item-text="name"
              item-value="id"
              label="Ledger Account"
              prepend-icon="book"
              v-model="journal_model.ledgeracc_id"
              :rules="validRules.required"
            />
            <v-text-field
              label="Description"
              prepend-icon="description"
              hint="please include student roll number in description if income is related to a particular student"
              v-model="journal_model.description"
              :rules="validRules.required"
            />

            <v-text-field
              label="Amount"
              v-model="journal_model.amount"
              :rules="validRules.required"
              prepend-icon="money"
              type="number"
              step="any"
            />

            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="journal_model.jdate"
              persistent
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="journal_model.jdate"
                  label="Date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  :rules="validRules.required"
                ></v-text-field>
              </template>
              <v-date-picker v-model="journal_model.jdate" scrollable>
                <div class="flex-grow-1"></div>
                <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(journal_model.jdate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-form>
        </template>

        <template v-slot:footer-actions>
          <v-btn
            style="cursor:pointer"
            color="success"
            @click="savejournal()"
            :loading="loading"
          >save</v-btn>
          <v-btn @click="showD=!showD" style="cursor:pointer" color="error">close</v-btn>
        </template>
      </inc-dialog>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "../../../components/Modal";
import { json2excel, excel2json } from "js2excel";
export default {
  layout: "accounts",
  name: "incomes-view",
  metaInfo() {
    return { title: this.$t("incomes") };
  },
  components: {
    "inc-dialog": Modal
  },
  data() {
    return {
      editedIndex: -1,
      search: "",
      showD: false,
      modal: false,
      journal_model: {
        ledgeracc_id: "",
        description: "",
        amount: "",
        type: "1",
        jdate: new Date().toISOString().substr(0, 10)
      },
      journal_modelcp: {
        name: "",
        description: "",
        amount: "",
        type: "1",
        jdate: new Date().toISOString().substr(0, 10)
      },
      inc_headers: [
        {
          text: "SN",
          align: "center",
          sortable: true,
          value: "level"
        },
        {
          text: "Ledger Account",
          align: "center",
          sortable: false,
          value: "ledgeracc.name"
        },
        {
          text: "Description",
          align: "center",
          sortable: false,
          value: "description"
        },
        {
          text: "Amount",
          align: "center",
          sortable: true,
          value: "amount"
        },
        {
          text: "Date",
          align: "center",
          sortable: false,
          value: "jdate"
        },
        {
          text: "Recorded By",
          align: "center",
          sortable: false,
          value: "recorded_by.name"
        },

        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "name"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("incomes/getAll", { type: 1 });
  },
  computed: {
    ...mapGetters({
      incomes: "incomes/INCOMES",
      ledgeraccs: "incomes/INCOME_LEDGERACCS",
      inerrors: "incomes/INCOME_ERROR",
      loading: "incomes/INCOME_LOADING"
    })
  },
  methods: {
    exportAllIncome() {
      if (!confirm("Click okay to confirm list export or cancel.")) {
        //confirm you want to send this reminder
        return;
      }

      let data = this.incomes.map(s => {
        return {
          "Ledger Account": s.ledgeracc.name,
          Description: s.description,
          Amount: s.amount,
          Date: s.jdate,
          "Recorded By": s.recorded_by ? s.recorded_by.name : "N/A"
        };
      });

      try {
        json2excel({
          data,
          name: "incomes-" + new Date().toISOString().substr(0, 10),
          formateDate: "yyyy/mm/dd"
        });
      } catch (e) {
        console.error("export error");
      }
    },
    addjournal() {
      this.$store.dispatch("incomes/add", this.journal_model);

      if (this.inerrors == null) {

        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Income added successfully.",
          title: "Income",
          modal: false
        });

          this.journal_model = {
          ledgeracc_id: "",
          description: "",
          amount: "",
          type: "1",
          jdate: new Date().toISOString().substr(0, 10)
        };
      }
    },
    deletejournal(journal, index) {
      if (confirm("Are you sure you want to delete this income?")) {
        this.$store.dispatch("incomes/delete", { journal, index });
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Income deleted successfully.",
          title: "Income",
          modal: false
        });
      }
    },

    editjournal(journal) {
      this.editedIndex = this.incomes.indexOf(journal);
      this.journal_model = Object.assign({}, journal);

      //alert(this.editedIndex)

      this.showD = true;
    },
    updatejournal(journal, index) {
      this.$store.dispatch("incomes/update", { index, journal });

      if (this.inerrors == null) {


        this.editedIndex = -1;
        this.showD = false;
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Income updated successfully.",
          title: "Income",
          modal: false
        });

         this.journal_model = {
          ledgeracc_id: "",
          description: "",
          amount: "",
          type: "1",
          jdate: new Date().toISOString().substr(0, 10)
        }

        //this.$store.dispatch("incomes/getAll", { type: 1 });

        //  setTimeout(()=>{
        //    window.location.reload();
        //  },100)
      } else {
        console.log(this.inerrors);
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "Sorry, income could not be updated",
          title: "Income",
          modal: false
        });
      }
    },
    savejournal() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing journal info or saving journal info
      if (this.editedIndex > -1) {
        this.updatejournal(this.journal_model, this.editedIndex);
      } else {
        this.addjournal();
      }
    }
  },
  watch: {
    showD(val) {
      if (val == false) {
        this.journal_model = {
          ledgeracc_id: "",
          description: "",
          amount: "",
          type: "1",
          jdate: new Date().toISOString().substr(0, 10)
        };
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/accountant/income/income.vue